module.exports = __webpack_public_path__ + "static/media/logo-letter-1-white.fd2e4fa6.png";